import { useCallback } from "react";
import { useDispatch } from "src/redux/hooks";
import {
  type IsAutosaveBlockedOptions,
  selectIsAutosaveBlocked,
} from "src/redux/selectors/selectIsAutosaveBlocked";
import { store } from "src/redux/store";

import { triggerAutosaveForExternalChange } from "./autosaveScheduler";

export const useTriggerAutoSave = () => {
  const dispatch = useDispatch();
  return useCallback(
    (options?: IsAutosaveBlockedOptions) => {
      if (selectIsAutosaveBlocked(store.getState(), options)) return;
      triggerAutosaveForExternalChange(dispatch, options);
    },
    [dispatch],
  );
};
